import { render, staticRenderFns } from "./WishlistItem.vue?vue&type=template&id=355cf73e&scoped=true"
import script from "./WishlistItem.vue?vue&type=script&lang=js"
export * from "./WishlistItem.vue?vue&type=script&lang=js"
import style0 from "./WishlistItem.vue?vue&type=style&index=0&id=355cf73e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355cf73e",
  null
  
)

export default component.exports